import { ScaffolderClient } from '@backstage/plugin-scaffolder';

/**
 * The stock client, except that the GitHub user token is checked at the moment
 * of submitting rather than trusted from when the form opened.
 *
 * GithubUserCredential puts the token into the form's secrets when the form
 * mounts. A form can sit open for a long time, and Start Over reuses the page,
 * so by the time Create is pressed that token may be one GitHub has already
 * refused - the task then dies at its first step with a bare 401. Swapping in
 * a just-verified token here closes that window for every template at once.
 */
export class VerifiedTokenScaffolderClient extends ScaffolderClient {
  constructor(
    options: ConstructorParameters<typeof ScaffolderClient>[0],
    private readonly freshToken: () => Promise<string>,
  ) {
    super(options);
  }

  override async scaffold(
    ...[request, options]: Parameters<ScaffolderClient['scaffold']>
  ) {
    if (!request.secrets?.USER_OAUTH_TOKEN) {
      return super.scaffold(request, options);
    }
    const token = await this.freshToken();
    return super.scaffold(
      { ...request, secrets: { ...request.secrets, USER_OAUTH_TOKEN: token } },
      options,
    );
  }
}
